import React from 'react';
import { BraintreeError, PayPalTokenizePayload } from 'braintree-web';
import { PrimaryLoadingButton } from 'components';
import { BraintreeClientType, useBraintree } from 'hooks/useBraintree';
import { PaypalButtonWrapper } from './styled/index';
import { useSelector, useDispatch } from 'react-redux';
import {
  shippingAddressSelector,
  totalSegmentsSelector,
  braintreeValidationStateSelector,
  placeOrderLoadingStateSelector
} from 'store/cart/selectors';
import QuoteDataAddress from 'mage-swagfaces/quote/QuoteDataAddress';
import { magentoAddressToPaypalAddress } from 'helpers/billing';
import QuoteDataTotalSegment from 'mage-swagfaces/quote/QuoteDataTotalSegment';
import { getGrandTotalFromTotalSegments } from 'store/cart/magentoSelectors';
import { newrelic } from 'helpers/reporting/newrelic';
import { EMPTY_OBJECT, isFetching } from 'store/constants';
import { braintreeValidationRequest, braintreeValidationFailure, placeOrderRequest } from 'store/cart/actions';
import itly from 'itly';
import { PAYMENT_METHOD_PAYPAL } from 'types/magento/CustomerPaymentMethod';

const PaypalButton = ({ disabled }: { disabled: boolean }): React.JSX.Element => {
  const dispatch = useDispatch();
  const braintreeValidationState = useSelector(braintreeValidationStateSelector);
  const placeOrderLoadingState = useSelector(placeOrderLoadingStateSelector);
  const isValidating = isFetching(placeOrderLoadingState) || isFetching(braintreeValidationState);
  const cartShippingAddress: QuoteDataAddress = useSelector(shippingAddressSelector);
  const totalSegments: QuoteDataTotalSegment[] = useSelector(totalSegmentsSelector);
  const grandTotal: number = getGrandTotalFromTotalSegments(totalSegments);

  const paypalTokenizeHandler = (err: BraintreeError, payload: PayPalTokenizePayload, deviceData: string) => {
    if (err) {
      newrelic('addPageAction')('BRAINTREE_PAYPAL_TOKENIZE_ERROR', { err });
      dispatch(braintreeValidationFailure(err.message));
      return;
    }

    dispatch(placeOrderRequest(payload));
  };

  useBraintree(BraintreeClientType.PAYPAL, {
    paypalTokenizeHandler,
    orderAmount: grandTotal.toFixed(2),
    shippingAddress: cartShippingAddress !== EMPTY_OBJECT ? magentoAddressToPaypalAddress(cartShippingAddress) : undefined,
    disabled: disabled
  });

  const handleClick = () => {
    itly.paymentMethodAtCheckout({ payment_method: PAYMENT_METHOD_PAYPAL });

    dispatch(braintreeValidationRequest());
  };

  return (
    <PaypalButtonWrapper>
      <PrimaryLoadingButton
        id="paypal-button"
        width="100%"
        isLoading={isValidating}
        onClick={handleClick}
        disabled={disabled}
        paypal
      >
        Purchase with Paypal
      </PrimaryLoadingButton>
    </PaypalButtonWrapper>
  );
};

export default PaypalButton;
